import type { FC } from 'react'

import { StyledText } from '@skytech/ui'

import { Translation } from '@/components/i18n/Translation'

export const RelatedCategoryList: FC<{ relatedCategories: string[] }> = ({ relatedCategories }) => (
  <div className="flex flex-row flex-wrap gap-1">
    {relatedCategories.map((category, idx) => (
      <StyledText key={category} size="small" colorMode="gray" className="m-0 w-fit text-start">
        <Translation id={category} />
        {idx < relatedCategories.length - 1 ? ', ' : ''}
      </StyledText>
    ))}
  </div>
)
